
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"attribute.unknown.name":"Unbekanntes Attribut","enrichment.label":"Datenanreicherung für:"},"en":{"attribute.unknown.name":"Unknown attribute","enrichment.label":"Data enrichment for:"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();